import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { TopbarComponent } from './shared/topbar/topbar.component';
import { BottomNavComponent } from './shared/bottom-nav/bottom-nav.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { BookingComponent } from './features/booking/booking.component';
import { SettingsComponent } from './features/settings/settings.component';
import { LoginComponent } from './features/login/login.component';
import { ProfessionalComponent } from './features/professional/professional.component';
import { ConfirmBookingComponent } from './features/confirm-booking/confirm-booking.component';
import { MyAppointmentsComponent } from './features/my-appointments/my-appointments.component';
import { PublicBookingComponent } from './features/public-booking/public-booking.component';
import { AvailabilityComponent } from './features/availability/availability.component';
import { SkeletonComponent } from './shared/skeleton/skeleton.component';
import { ToastComponent } from './shared/toast/toast.component';
import { OnboardingComponent } from './features/onboarding/onboarding.component';

@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    TopbarComponent,
    BottomNavComponent,
    DashboardComponent,
    BookingComponent,
    SettingsComponent,
    LoginComponent,
    ProfessionalComponent,
    ConfirmBookingComponent,
    MyAppointmentsComponent,
    PublicBookingComponent,
    AvailabilityComponent,
    SkeletonComponent,
    ToastComponent,
    OnboardingComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
